<header class="navbar-custom">
  <!-- Left section -->
  <div class="navbar-left">
    <!-- Desktop sidebar toggle (visible on large screens) -->
    <button
      class="btn-desktop-toggle d-none d-xl-flex align-items-center justify-content-center me-3"
      id="desktop-sidebar-toggle"
      aria-label="Minimizar Menu"
      (click)="layoutService.toggleDesktopSidebar()"
    >
      <i
        class="bi"
        [class.bi-chevron-bar-right]="layoutService.isSidebarMinimized()"
        [class.bi-chevron-bar-left]="!layoutService.isSidebarMinimized()"
      ></i>
    </button>

    <!-- Mobile sidebar toggle -->
    <button
      class="sidebar-toggle-btn me-2 d-xl-none"
      id="sidebar-toggle"
      aria-label="Abrir Menu"
      (click)="layoutService.toggleMobileSidebar()"
    >
      <i class="bi bi-list"></i>
    </button>

    <!-- Brand / Title -->
    <div class="d-flex align-items-center me-3">
      <span class="fw-bold text-main fs-5 me-3">Equity+</span>
    </div>

    <!-- Company Selector Dropdown -->
    @if (userContext.userCompanies().length > 0) {
      <div class="dropdown">
        <button
          class="btn btn-outline-primary btn-sm dropdown-toggle d-flex align-items-center gap-2"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i class="bx bx-building fs-6"></i>
          <span class="fw-semibold text-truncate" style="max-width: 180px">
            {{ userContext.selectedCompany()?.companyName || 'Selecione a Empresa' }}
          </span>
          <span
            class="badge ms-1"
            [ngClass]="userContext.selectedCompany()?.role === CompanyRole.Operational ? 'bg-primary' : 'bg-secondary'"
          >
            {{ userContext.selectedCompany()?.role === CompanyRole.Operational ? 'Operacional' : 'Leitor' }}
          </span>
        </button>
        <ul class="dropdown-menu dropdown-menu-start shadow-sm">
          <li>
            <h6 class="dropdown-header text-uppercase small text-muted">Empresas Vinculadas</h6>
          </li>
          @for (comp of userContext.userCompanies(); track comp.companyId) {
            <li>
              <button
                class="dropdown-item d-flex align-items-center justify-content-between py-2"
                [class.active]="comp.companyId === userContext.selectedCompany()?.companyId"
                (click)="onSelectCompany(comp.companyId)"
              >
                <div class="d-flex align-items-center me-3">
                  <i
                    class="bx bx-check me-2 text-primary"
                    [class.invisible]="comp.companyId !== userContext.selectedCompany()?.companyId"
                  ></i>
                  <span class="fw-semibold">{{ comp.companyName }}</span>
                </div>
                <span
                  class="badge ms-2"
                  [ngClass]="comp.role === CompanyRole.Operational ? 'bg-label-primary' : 'bg-label-secondary'"
                >
                  {{ comp.role === CompanyRole.Operational ? 'Operacional' : 'Leitor' }}
                </span>
              </button>
            </li>
          }
        </ul>
      </div>
    } @else if (!userContext.isLoadingContext()) {
      <div class="badge bg-label-warning text-warning d-flex align-items-center gap-1">
        <i class="bx bx-error-circle"></i>
        <span>Nenhuma empresa vinculada</span>
      </div>
    }
  </div>

  <!-- Right section: User Profile, Theme Toggle & Fullscreen -->
  <div class="navbar-actions ms-auto d-flex align-items-center gap-2">
    <!-- Dark Mode Toggle -->
    <button
      class="btn btn-link nav-link px-2 text-muted"
      type="button"
      (click)="themeService.toggleTheme()"
      [title]="themeService.isDarkMode() ? 'Modo claro' : 'Modo escuro'"
    >
      <i
        class="bx bx-sm"
        [class.bx-sun]="themeService.isDarkMode()"
        [class.bx-moon]="!themeService.isDarkMode()"
      ></i>
    </button>

    <!-- Fullscreen Toggle -->
    <button
      class="btn btn-link nav-link px-2 text-muted"
      type="button"
      aria-label="Tela cheia"
      (click)="toggleFullscreen()"
      title="Alternar tela cheia"
    >
      <i class="bx bx-fullscreen bx-sm"></i>
    </button>

    <!-- Profile Dropdown -->
    <div class="dropdown">
      <button
        class="btn btn-link nav-link dropdown-toggle hide-arrow d-flex align-items-center p-0 text-decoration-none"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        id="profile-dropdown"
      >
        <img
          [src]="authService.user()?.photoURL || '/assets/img/avatars/no-photo.jpg'"
          alt="Avatar"
          class="rounded-circle me-2 border"
          style="width: 34px; height: 34px; object-fit: cover;"
        />
        <div class="d-none d-md-block text-start me-1">
          <span class="fw-semibold d-block text-truncate" style="max-width: 140px; font-size: 0.85rem;">
            {{ authService.user()?.displayName || 'Usuário' }}
          </span>
          <small class="text-muted text-truncate d-block" style="max-width: 140px; font-size: 0.75rem;">
            {{ authService.user()?.email }}
          </small>
        </div>
      </button>
      <ul
        class="dropdown-menu dropdown-menu-end shadow-sm"
        aria-labelledby="profile-dropdown"
      >
        <li>
          <div class="dropdown-item py-2">
            <div class="d-flex align-items-center">
              <div class="flex-shrink-0 me-3">
                <img
                  [src]="authService.user()?.photoURL || '/assets/img/avatars/no-photo.jpg'"
                  class="rounded-circle border"
                  style="width: 36px; height: 36px; object-fit: cover;"
                />
              </div>
              <div class="flex-grow-1">
                <span class="fw-semibold d-block" style="font-size: 0.9rem;">{{
                  authService.user()?.displayName || 'Usuário'
                }}</span>
                <small class="text-muted d-block" style="font-size: 0.78rem;">{{ authService.user()?.email }}</small>
                @if (userContext.isGlobalAdmin()) {
                  <span class="badge bg-danger mt-1">Admin Global</span>
                }
              </div>
            </div>
          </div>
        </li>
        <li>
          <hr class="dropdown-divider my-1" />
        </li>
        <li>
          <button class="dropdown-item text-danger py-2" (click)="onLogout()">
            <i class="bx bx-power-off me-2"></i>
            <span class="align-middle">Sair</span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</header>
